import React, { Component } from 'react';
import { connect } from 'dva';
import { Spin, Tabs, Divider, Table, Checkbox, Button, Modal } from 'antd';
import BreadNav from '@/components/BreadNav';
import AddModal from './AddModal/index';
import { getCurrentBreadCrumbs } from '@/utils';
import styles from './index.less';

const { TabPane } = Tabs;
const { confirm } = Modal;

@connect(({ personnelSetting }) => ({
  ...personnelSetting,
}))
class Setting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false, // 添加自定义字段modal的显示隐藏状态
      // 面包屑
      breadcrumb: getCurrentBreadCrumbs({
        currentUrl: {
          context: '字段设置',
          path: `/contacts/personnel/setting${window.location.search}`,
        },
        storekey: 'managementCenterBreadcrumb',
      }),
    };

    this.handleTabsChange = this.handleTabsChange.bind(this);
    this.fetchExtraStatausChange = this.fetchExtraStatausChange.bind(this);
    this.handleSortNumChange = this.handleSortNumChange.bind(this);
    this.handleAddModalVisibleChange = this.handleAddModalVisibleChange.bind(this);
    this.handleGetColumns = this.handleGetColumns.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
  }

  // 修改状态状态
  fetchExtraStatausChange(record, newStatus) {
    const { dispatch, currentTabKey, orgRoleAttributeInfoSettings } = this.props;

    const newData = Object.assign({}, record, { ...newStatus, roleSign: currentTabKey });

    dispatch({
      type: 'personnelSetting/fetchExtraStatausChange',
      params: newData,
      orgRoleAttributeInfoSettings,
    });
  }

  // 获取表头
  handleGetColumns(orgRoleAttributeInfoSettings) {
    return [
      {
        title: '成员信息',
        dataIndex: 'attributeName',
      },
      {
        title: '是否启用',
        dataIndex: 'isValid',
        render: (isValid, record) => {
          const { isDisabled, isRequired } = record;
          return (
            <Checkbox
              onChange={e =>
                this.fetchExtraStatausChange(record, { isValid: e.target.checked ? '1' : '0' })
              }
              disabled={isDisabled || isRequired === '1'}
              checked={isValid === '1'}
            />
          );
        },
      },
      {
        title: '是否必填',
        dataIndex: 'isRequired',
        render: (isRequired, record) => {
          const { isDisabled } = record;
          return (
            <Checkbox
              onChange={e =>
                this.fetchExtraStatausChange(record, {
                  isRequired: e.target.checked ? '1' : '0',
                  isValid: '1',
                })
              }
              disabled={isDisabled}
              checked={isRequired === '1'}
            />
          );
        },
      },
      {
        title: '操作',
        dataIndex: '',
        render: record => {
          const { isDisabled, sort } = record;
          const len = orgRoleAttributeInfoSettings.length;

          return (
            <span className="table-action-box">
              <a
                className="table-action-delete"
                onClick={() => this.handleDelete(record)}
                disabled={isDisabled}
              >
                删除
              </a>
              <Divider type="vertical" />
              <a
                className="table-action-delete"
                onClick={() => this.handleSortNumChange(record, -1)}
                disabled={isDisabled || sort === 0 || len === 1}
              >
                上移
              </a>
              <Divider type="vertical" />
              <a
                className="table-action-delete"
                onClick={() => this.handleSortNumChange(record, +1)}
                disabled={isDisabled || sort === len - 1 || len === 1}
              >
                下移
              </a>
            </span>
          );
        },
      },
    ];
  }

  // 删除
  handleDelete({ id, attributeName }) {
    const { dispatch, currentTabKey, orgRoleAttributeInfoSettings } = this.props;

    confirm({
      title: `删除${attributeName}`,
      content: '是否确认删除',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        dispatch({
          type: 'personnelSetting/fetchDel',
          params: { id, roleSign: currentTabKey },
          orgRoleAttributeInfoSettings,
        });
      },
    });
  }

  // 修改排序
  handleSortNumChange({ id }, num) {
    const { dispatch, currentTabKey, orgRoleAttributeInfoSettings } = this.props;

    dispatch({
      type: 'personnelSetting/fetchSort',
      params: { sourceId: id, roleSign: currentTabKey, num },
      orgRoleAttributeInfoSettings,
    });
  }

  // tab切换
  handleTabsChange(key) {
    const { dispatch } = this.props;
    const { currentTabKey } = this.state;

    if (currentTabKey !== key) {
      dispatch({
        type: 'personnelSetting/fetchExtraInfo',
        searchParams: { roleSign: key },
      });
    }
  }

  // 切换modal状态
  handleAddModalVisibleChange(visible = false) {
    this.setState({
      visible,
    });
  }

  // 添加自定义字段
  handleAdd(params) {
    const { dispatch } = this.props;

    dispatch({
      type: 'personnelSetting/fetchAdd',
      params,
      callback: this.handleAddModalVisibleChange,
    });
  }

  render() {
    const { breadcrumb, visible } = this.state;
    const {
      spinProps,
      currentTabKey,
      extraRoleList,
      baseInfoSettings = [],
      orgRoleAttributeInfoSettings = [],
      managementEntityRoleInfoSettings = [],
    } = this.props;

    const dataSource = [
      ...baseInfoSettings,
      ...managementEntityRoleInfoSettings,
      ...orgRoleAttributeInfoSettings,
    ];

    const tableProps = {
      columns: this.handleGetColumns(orgRoleAttributeInfoSettings),
      dataSource,
      rowKey: 'id',
      pagination: false,
      scroll: { x: true },
    };

    return (
      <div className={styles.setting}>
        <Spin {...spinProps}>
          <BreadNav key="breadNav" dataSource={breadcrumb} />

          <div className="content-container">
            <Button type="primary" onClick={() => this.handleAddModalVisibleChange(true)}>
              添加自定义信息
            </Button>
            <Tabs onChange={this.handleTabsChange} type="card" activeKey={currentTabKey}>
              {extraRoleList.map(({ roleName, roleSign }) => (
                <TabPane tab={roleName} key={roleSign} />
              ))}
            </Tabs>

            <div className="tab-container">
              <Table {...tableProps} />
            </div>

            {visible !== false && (
              <AddModal
                roleSign={currentTabKey}
                handleOk={this.handleAdd}
                handleCancel={this.handleAddModalVisibleChange}
              />
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
export default Setting;
